import { useState, useEffect } from "react";
// material
import {
  Box,
  Card,
  Typography,
  TableCell,
  TableBody,
  TableContainer,
  Table,
  TableRow,
} from "@mui/material";
// components
import { Log, sendDataWithPost } from "../../services/services";

import ListHead from "../../components/table/ListHead";
import Scrollbar from "../../components/table/Scrollbar";
import { StyledTableRow } from "../../components/TableRow";
import { isEmpty } from "lodash";

import FormSearch from "../../components/FormSearch";
import CircularLoader from "../../components/circularLoader";
import Pagination from "../../components/Pagination";

// ----------------------------------------------------------------------

const defaultValue = {};

const TABLE_HEAD = [
  { id: "id", label: "Business ID" },
  { id: "business_name", label: "Business Name" },
  { id: "uen", label: "UEN" },
  { id: "registered_country", label: "Registered Country" },
  { id: "postal_code", label: "Postal Code" },
  { id: "address_country", label: "Address Country" },
  { id: "data_merchant_payout", label: "Merchant Payout Data" },
];

export default function BusinessEntity() {
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState({
    results: [],
    count: 0
  });
  const [filter, setFilter] = useState({});

  // ------------------ filterStuffies --------------------//
  const [pagination, setPagination] = useState({ page: 1, page_size: 50 });

  const handleChangePage = (event, newPage) => {
    queryList({
      page: newPage + 1,
      page_size: pagination.page_size,
    }, filter);
  };

  const handleChangeRowsPerPage = (event) => {
    queryList({
      page: 1,
      page_size: event.target.value,
    }, filter);
  };

  const queryList = (params, filterParams) => {
    loaded && setLoaded(false);
    queryPage(params, filterParams);
  };

  const queryPage = (params, filterParams) => {
    const queryParams = new URLSearchParams(params || pagination).toString();
    const url = `/payout/ingestor_merchant/business_entity_list/?${queryParams}`;
    sendDataWithPost(url, filterParams, setTableData, setLoaded, () => {
      params && setPagination(params);
    });
  };

  const onFilterSubmit = (fParams) => {
    const newFParams = {
      ...fParams,
      business_id: fParams.business_id?.trim(),
      business_name: fParams.business_name?.trim(),
      merchant_id: fParams.merchant_id?.trim(),
      merchant_name: fParams.merchant_name?.trim()
    };
    const newPagination = {
      ...pagination,
      page: 1,
    };
    
    Log.info("Search Business Entity list", newFParams);
    setFilter(newFParams);
    queryList(newPagination, newFParams);
  };

  // ------------------ end of filter stuffies --------------------//

  useEffect(() => {
    onFilterSubmit(defaultValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isDataNotFound = tableData?.results?.length === 0;

  const schema = [
    {
      type: "text",
      label: "Business ID",
      param: "business_id",
    },
    {
      type: "text",
      label: "Business Name",
      param: "business_name",
    },
    {
      type: "text",
      label: "Merchant ID",
      param: "merchant_id",
    },
    {
      type: "text",
      label: "Merchant Name",
      param: "merchant_name",
    }
  ];

  const renderMerchantPayout = (data) => {
    if (!data || !Array.isArray(data) || data.length === 0) return "-";
    return data.map((m, idx) => (
      <div key={idx} style={{ paddingBottom: 4 }}>
        {m.merchant_id} ({m.source?.toUpperCase()}) {m.merchant_name ? `- ${m.merchant_name}` : ''}
      </div>
    ));
  };

  return (
    <Box>
      <FormSearch
        schema={schema}
        loading={!loaded}
        onSearch={onFilterSubmit}
        defaultValue={defaultValue}
      />
      {loaded ? (
        <Card>
          <Scrollbar>
            <TableContainer>
              <Table>
                <ListHead
                  headLabel={TABLE_HEAD}
                  checkbox={false}
                />
                <TableBody>
                  {tableData?.results?.map((row, i) => {
                    const {
                      id,
                      business_name,
                      uen,
                      registered_country,
                      postal_code,
                      address_country,
                      data_merchant_payout
                    } = row;

                    return (
                      <StyledTableRow hover key={id || i}>
                        <TableCell align="left">{id}</TableCell>
                        <TableCell align="left">{business_name}</TableCell>
                        <TableCell align="left">{uen}</TableCell>
                        <TableCell align="left">{registered_country}</TableCell>
                        <TableCell align="left">{postal_code}</TableCell>
                        <TableCell align="left">{address_country}</TableCell>
                        <TableCell align="left">
                            {renderMerchantPayout(data_merchant_payout)}
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
                {isDataNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                        <Typography gutterBottom align="center" variant="subtitle1">
                          Not found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          {!isEmpty(tableData?.results) && (
            <Pagination
              count={tableData.count}
              pagination={pagination}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Card>
      ) : (
        <CircularLoader />
      )}
    </Box>
  );
}
